import { Component, Input, OnChanges, OnInit, Renderer2, ViewChild } from '@angular/core';

@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.scss'],
})
export class PdfViewerComponent implements OnInit, OnChanges {
  @Input() file: File;
  @ViewChild('pdfViewer', { static: true }) pdfViewer;

  constructor(private renderer2: Renderer2) {}

  ngOnInit() {}

  ngOnChanges(): void {
    if (this.file) {
      const base64 = this.arrayBufferToBase64(this.file);
      const base64Url = `data:application/pdf;base64,${base64}`;
      this.renderer2.setAttribute(this.pdfViewer.nativeElement, 'src', base64Url);
      //this.pdfViewer.nativeElement.src = base64Url;
    }
  }

  arrayBufferToBase64(buffer) {
    var binary = '';
    var bytes = new Uint8Array(buffer);
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }
}
